<script>
import logo from '@/assets/logo.png'

export default {
  name: "MyAside",
  data() {
    return {
      plugins: [],
      logo: logo,
      uid: null,
      loading: false
    }
  },
  created(){
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      try {
        this.uid = JSON.parse(userInfo).id
        this.loadPlugins()
      } catch (e) {
        console.error('解析用户信息失败', e)
      }
    }
  },
  methods:{
    loadPlugins() {
      if (!this.uid) return
      
      this.loading = true
      this.$axios({
        method: 'get',
        url: '/PluginList/getList',
        params: {
          uid: this.uid
        }
      }).then(response => {
        if (response.data.code === "200" || response.data.success) {
          this.plugins = response.data.data.pluginList
          if (this.plugins.length > 0) {
            localStorage.setItem('selectPlugin', JSON.stringify(this.plugins[0]))
            // 触发父组件事件
            this.$emit('plugin-selected', this.plugins[0])
          }
        }
        if (response.data.code === "203") {
          this.$message.warning(response.data.data.message)
        }
      }).catch(error => {
        console.error('加载插件列表失败', error)
        this.$message.error('加载插件列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    selectPlugin(plugin) {
      localStorage.setItem('selectPlugin', JSON.stringify(plugin))
      // 触发父组件事件
      this.$emit('plugin-selected', plugin)
    }
  }
}
</script>

<template>
  <div class="aside-container">
    <div class="aside-header">
      <img :src="logo" alt="Mild插件" class="aside-logo">
    </div>
    <el-menu
        default-active="1"
        class="aside-menu"
        background-color="#3a3f51"
        text-color="#c0c4cc"
        active-text-color="#667eea"
        :unique-opened="true"
        :collapse-transition="true"
    >
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-apps"></i>
          <i class="el-icon-s-tools"></i>
          <span>我的插件</span>
        </template>
        <el-menu-item-group>
          <el-menu-item
              v-for="plugin in plugins"
              :key="plugin.id"
              :index="'plugin-' + plugin.id"
              @click="selectPlugin(plugin)"
              class="plugin-menu-item"
          >
            <i class="el-icon-extension"></i>
            <span>{{ plugin.pluginName }}</span>
          </el-menu-item>
          <el-menu-item v-if="plugins.length === 0" disabled class="no-plugin-item">
            <i class="el-icon-info"></i>
            <span>暂无插件</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<style scoped>
.aside-container {
  height: 100vh;
  background: #3a3f51;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.aside-header {
  padding: 20px 0;
  text-align: center;
  border-bottom: 1px solid #4a4f61;
  transition: all 0.3s ease;
}

.aside-logo {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  background: white;
  padding: 10px;
  transition: all 0.3s ease;
}

.aside-logo:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.aside-menu {
  flex: 1;
  border-right: none;
  overflow-y: auto;
}

/* 菜单样式 */
::v-deep .el-menu {
  background: transparent;
}

::v-deep .el-menu-item,
::v-deep .el-submenu__title {
  height: 50px;
  line-height: 50px;
  margin: 0 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

::v-deep .el-menu-item:hover,
::v-deep .el-submenu__title:hover {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
}

::v-deep .el-menu-item.is-active {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2));
  color: #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

::v-deep .el-submenu__title {
  color: #c0c4cc;
}

::v-deep .el-submenu__title:hover {
  color: #667eea;
}

::v-deep .el-submenu__title i {
  transition: all 0.3s ease;
}

::v-deep .el-submenu.is-opened .el-submenu__title i {
  transform: rotate(90deg);
  color: #667eea;
}

/* 插件菜单项 */
.plugin-menu-item {
  position: relative;
  overflow: hidden;
}

.plugin-menu-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #667eea;
  transform: scaleY(0);
  transition: all 0.3s ease;
}

.plugin-menu-item:hover::before,
.plugin-menu-item.is-active::before {
  transform: scaleY(1);
}

/* 无插件状态 */
.no-plugin-item {
  opacity: 0.6;
}

/* 滚动条样式 */
::v-deep .el-menu::-webkit-scrollbar {
  width: 6px;
}

::v-deep .el-menu::-webkit-scrollbar-track {
  background: #3a3f51;
}

::v-deep .el-menu::-webkit-scrollbar-thumb {
  background: #4a4f61;
  border-radius: 3px;
}

::v-deep .el-menu::-webkit-scrollbar-thumb:hover {
  background: #5a5f71;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .aside-container {
    width: 60px !important;
  }
  
  .aside-logo {
    width: 40px;
    height: 40px;
  }
  
  ::v-deep .el-menu-item span,
  ::v-deep .el-submenu__title span {
    display: none;
  }
  
  ::v-deep .el-menu-item,
  ::v-deep .el-submenu__title {
    text-align: center;
  }
}
</style>